module.exports = function(bh) {
    bh.match('navigation-panel', function(ctx, json) {
        ctx.attr('id', ctx.tParam('ID'));
    });
};
